import Rest from '@/services/Rest';

/**
 * @typedef {BankAccountService}
 */
export default class BankAccountService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/bank-account'
}
